'use client';

import { Modal as HeroModal } from '@heroui/react';
import { ReactNode } from 'react';

import { Container } from './Container';
import { HStack } from './Stack';
import { Text } from './Text';

export interface ModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  body: ReactNode | ((props: { close: () => void }) => ReactNode);
  title?: ReactNode;
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'full' | 'cover' | 'xs';
  placement?: 'auto' | 'top' | 'center' | 'bottom';
  backdrop?: 'transparent' | 'opaque' | 'blur';
  scroll?: 'inside' | 'outside';
}

export const Modal = ({
  isOpen,
  onOpenChange,
  body,
  title,
  footer,
  size = 'md',
  placement = 'center',
  backdrop = 'blur',
  scroll = 'outside',
}: ModalProps) => {
  return (
    <HeroModal.Backdrop
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      variant={backdrop}
      isDismissable={true}
      className="z-[9999]"
      onClick={() => {
        onOpenChange(false);
      }}
    >
      <HeroModal.Container
        size={size}
        placement={placement}
        scroll={scroll}
        className="z-[9999]"
      >
        <HeroModal.Dialog
          className="bg-white rounded-3xl p-6 shadow-2xl border border-gray-100 relative pointer-events-auto"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {(renderProps) => (
            <>
              <HeroModal.CloseTrigger />
              {title && (
                <HeroModal.Header className="pb-4 border-b border-gray-100 pr-10">
                  {typeof title === 'string' ? (
                    <Text variant="h3" weight="bold">
                      {title}
                    </Text>
                  ) : (
                    title
                  )}
                </HeroModal.Header>
              )}
              <HeroModal.Body className="py-4">
                <Container fullWidth>
                  {typeof body === 'function' ? body(renderProps) : body}
                </Container>
              </HeroModal.Body>
              {footer && (
                <HeroModal.Footer className="pt-4 border-t border-gray-100">
                  <HStack fullWidth align="center" justify="end" gap={2}>
                    {footer}
                  </HStack>
                </HeroModal.Footer>
              )}
            </>
          )}
        </HeroModal.Dialog>
      </HeroModal.Container>
    </HeroModal.Backdrop>
  );
};
